import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config";
import Button from "react-bootstrap/Button";


/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
export const LogInButton = (props: { type?: string }) => {
    const { instance } = useMsal();
    console.log("Type: ",props)
    const handleLogin = (loginType: string) => {
        if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }
    return (
        <Button variant={props.type || "link"} className="ml-auto text-right" onClick={() => handleLogin("redirect")}>Sign in</Button>
    );
}